<template lang="pug">
  v-stepper(v-model="step" v-if="content")
    v-stepper-items
      v-stepper-content(step="1" )
        v-container(grid-list-md)
          v-layout(wrap)
            v-flex(lg6 md6 xs12)
              v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                template(v-slot:prepend)
                  v-icon(color="warning") mdi-credit-card-multiple-outline
            v-flex(lg5 md5 xs12)
              v-text-field(dense v-model="content.summary.productDescription.toUpperCase()" label="Jenis Transaksi" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg6 md6 xs12 v-if="content.note")
              v-text-field(dense v-model="content.note" label="Berita" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-note-text-outline
            v-flex(lg5 md5 xs12 v-if="content.customerRef")
              v-text-field(dense v-model="content.customerRef" label="No. Dokumen" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-file-document-outline
            v-flex(lg6 md6 xs12)
              v-text-field(dense v-model="destination" label="No Rekening Tujuan" readonly)
                template(v-slot:prepend)
                  v-icon(color="success") mdi-credit-card-multiple-outline
          v-layout(wrap v-if="!edit")
            v-flex(lg12 md12 xs12 )
              v-layout(wrap)
                v-flex(lg12 md12 xs12)
                  div(class="caption font-weight-bold primary--text") Transaksi Melalui
                    v-radio-group(dense v-model="type" row readonly)
                      v-radio(label="Transfer" :value="0" color="primary")
                      v-radio(v-if="!withoutTrfOnl" label="Transfer Antar Bank" :value="1" color="primary")
                      v-radio(label="SKN" :value="2" color="primary")
                      v-radio(label="RTGS" :value="3" color="primary")
          v-layout(wrap)
            v-flex(lg4 md4 xs12)
              v-text-field(dense v-model="content.info.noTransaksi" label="No. Transaksi" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg2 md2 xs12)
              v-text-field(dense v-model="content.info.kasdaId" label="Kode Pemda" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg2 md2 xs12)
              v-text-field(dense v-model="content.info.tahun" label="Tahun" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg3 md3 xs12)
              v-text-field(dense v-if="content.info.npwp" v-model="content.info.npwp" label="NPWP" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg8 md8 xs12 v-if="content.info.namaSkpd")
              v-text-field(dense v-model="content.info.namaSkpd" label="Nama SKPD" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-account-details-outline
            v-flex(lg6 md6 xs12 v-if="content.info.namaSub")
              v-text-field(dense v-model="content.info.namaSub" label="Dinas" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-account-details-outline
            v-flex(lg11 md11 xs12)
              v-text-field(dense v-model="content.info.keterangan" label="Keterangan" readonly)
                template(v-slot:prepend)
                  v-icon(color="primary") mdi-checkbox-marked-outline
          v-layout(wrap)
            v-flex(lg5 md5 xs12 v-if="request && request.data && request.data.amountParameters && request.data.amountParameters")
              f-decimalbox(v-model="request.data.amountParameters.amount" label="Nilai Bruto" readonly :template="true")
          v-layout(wrap)
            v-flex(lg5 md5 xs12)
              f-decimalbox(v-model="potongan" label="Potongan" readonly :template="true")
          v-layout(wrap)
            v-flex(lg5 md5 xs12 v-if="request && request.data && request.data.amountParameters && request.data.amountParameters.feeExclude > 0")
              f-decimalbox(v-model="request.data.amountParameters.feeExclude" label="Admin (Dibebankan ke rekening sumber)" readonly :template="true")
          v-layout(wrap)
            v-flex(lg5 md5 xs12 v-if="request && request.data && request.data.amountParameters && request.data.amountParameters")
              f-decimalbox(v-model="request.data.amountParameters.feeInclude" label="Admin" readonly :template="true")
          v-layout(wrap)
            v-flex(lg5 md5 xs12  v-if="request && request.data && request.data.amountParameters && request.data.amountParameters")
              f-decimalbox(v-model="request.data.amountParameters.total" label="Nilai Yang Diterima" readonly :template="true")
          v-layout(wrap v-if="content.info.listPotongan")
            v-flex(lg12 md12 xs12)
              f-pemda-potongan-table(:data="content.info.listPotongan" :edit="edit"
                :reinquiry="reinquiry"
                :reverse="reverse"
                :billingTransaction="billingTransaction"
                :billingUpdate="billingUpdate"
                v-on:data="showChangeBillingType($event)"
                v-on:detail="doViewDetail($event)"
                v-on:reset="emitEvents('reset')"
                v-on:transaction="doTransaction($event)"
                v-on:updateBilling="showChangeBillingType($event)"
                v-on:detailPhri="doViewDetailPhri($event)")
      v-stepper-content(step="2")
         f-billing-form(:billingData="billing" v-on:billing="showContent($event)" :back="true" v-on:doBack="doReset" :mapData="mapData" :payTypeData="payTypeData" :auto="autoInquiry" :content="content")
      v-stepper-content(step="3")
        f-billing-content(:billingData="billing" v-on:back="doReset")
      v-stepper-content(step="4")
        f-phri-content(:phriData="detail" v-on:back="doReset")
      v-stepper-content(step="5")
        v-form(ref="formBilling" id="formBilling" @submit.prevent="changeBillnum" lazy-validation)
          v-layout(wrap)
            v-flex(lg6 md6 xs12)
              v-text-field(dense v-model="newBillnum" label="Kode Billing Baru" maxlength="15" :rules="[v => !!v || 'Input kode billing Baru']" required)
                template(v-slot:prepend)
                  v-icon(color="warning") mdi-checkbox-marked-outline
          div(justify-center style="text-align: center;" class="ma-2 menu-btn")
            v-btn(class="mx-1" @click="doReset") Kembali
              v-icon mdi-arrow-left-circle
            v-btn(color="btnprimary white--text" class="mx-1" type="submit" form="formBilling" :disabled="changeSuccess") Proses
              v-icon mdi-arrow-right-circle
      v-stepper-content(step="6")
        v-container(grid-list-md)
          v-layout(wrap)
            v-flex(lg6 md6 xs12)
              v-radio-group(dense v-model="changeBillingType")
                v-radio(label="Pembuatan Billing Baru" value="CREATE" color="primary")
                v-radio(label="Masukan Billing Baru" value="CHANGE" color="primary")
          div(justify-center style="text-align: center;" class="ma-2 menu-btn")
            v-btn(class="mx-1" @click="doReset") Kembali
              v-icon mdi-arrow-left-circle
            v-btn(color="btnprimary white--text" class="mx-1" @click="setFormChangeBilling") Lanjutkan
              v-icon mdi-arrow-right-circle


</template>
<script>
export default {
  name: "FPemdaTransactionContent",
  props: ["referenceId", "content", "request", "transaction", "edit",
    "reinquiry", "reverse", "billingTransaction", "billingUpdate","withoutTrfOnl"],
  data() {
    return {
      step: "1",
      billing: null,
      editIndex: -1,
      editItem: {},
      readonly: false,
      mapData: [],
      payTypeData: [],
      autoInquiry: false,
      newBillnum: null,
      changeSuccess: false,
      phri: null,
      changeBillingType: "CHANGE",
    }
  },
  computed: {
    source() {
      return this.$options.filters.accountformat(this.content.source) + (this.content.sourceName ? (" - " + this.content.sourceName)
          : (" - " + this.request.data.sourceName));
    },
    destination() {
      return "(" + this.content.info.namaBank + ") " + this.$options.filters.accountformat(this.content.info.rekeningPenerima) + " - " + (this.content.info.namaRekeningPenerima ? this.content.info.namaRekeningPenerima : this.content.info.namaPenerima);
    },
    potongan(){
      return this.content.info.total - this.content.info.nilai;
    },
    type() {
      return this.content.parameters.transactionType
    }
  },
  watch: {
    content(val){
      this.doReset();
    }
  },
  mounted() {
    this.doReset();
  },
  methods: {
    doReset(dataBilling){
      this.step = "1";
      this.billing = dataBilling;
      this.autoInquiry = false;
      this.changeSuccess = false;
      this.phri = null;
      this.$emit("showButton");
      if (this.$refs.formBilling) {
        this.$refs.formBilling.resetValidation();
      }
    },
    doCreateBilling(item){
      this.readonly = false;
      this.editIndex = this.content.info.listPotongan.indexOf(item);
      this.editItem = Object.assign({}, item);
      this.setDataMap(this.editItem);
      this.autoInquiry = true;
      this.billing = {
        useNpwp: item.billing.npwp !== null,
        npwp: item.billing.npwp,
        mapTransaction: item.billing.kodeMap,
        jenisSetor: item.billing.jenisSetoran==null?item.billing.jenisSetor:item.billing.jenisSetoran,
        nama: item.billing.namaWajibPajak,
        alamat: item.billing.alamatWajibPajak,
        kota: item.billing.kotaWajibPajak,
        periode1: item.billing.periode1,
        periode2: item.billing.periode2,
        tahun: item.billing.tahun,
        noKetetapan: item.billing.noKetetapan,
        npwpSetor: item.billing.npwpSetor,
        kpp: item.billing.kpp,
        nop: item.billing.nop,
        billNumber: item.billing.billnum,
        expiredDate: item.billing.expiredDate,
        idWajibPajak: item.billing.idWajibPajak,
        amount: item.billing.amount,
        namaMap: item.billing.namaMap,
        namaJenisSetor: item.billing.namaJenisSetor,
        namaSetor: item.billing.namaSetor,
        kdSkpd: this.content.info.kodeBidang==null?"-":this.content.info.kodeUrusan+(this.content.info.kodeBidang.length>1?this.content.info.kodeBidang:("0"+this.content.info.kodeBidang))+this.content.info.kodeUnit+this.content.info.kodeSubUnit,
        noSpm: this.content.info.noSpm,
        additionalData: {
          map: {
            mapId: item.billing.kodeMap,
            description: item.billing.namaMap
          },
          payType: {
            payType: item.billing.jenisSetoran==null?item.billing.jenisSetor:item.billing.jenisSetoran,
            description: item.billing.namaJenisSetoran
          }
        }
      }
      this.$emit("hideButton");
      this.step = "2";
    },
    doViewDetail(item){
      this.setBillingData(item);
      this.$emit("hideButton");
      this.step = "3";
    },
    setBillingData(item){
      this.readonly = true;
      this.editItem = Object.assign({}, item);
      this.billing = {
        npwpRekanan:item.billing.npwpRekanan==null?null:item.billing.npwpRekanan ,
        nikRekanan:item.billing.nikRekanan==null?null:item.billing.nikRekanan ,
        useNpwp: item.billing.npwp !== null,
        npwp: item.billing.npwp,
        mapTransaction: item.billing.kodeMap,
        jenisSetor: item.billing.jenisSetoran==null?item.billing.jenisSetor:item.billing.jenisSetoran,
        nama: item.billing.namaWajibPajak,
        alamat: item.billing.alamatWajibPajak,
        kota: item.billing.kotaWajibPajak,
        periode1: item.billing.periode1,
        periode2: item.billing.periode2,
        tahun: item.billing.tahun,
        noKetetapan: item.billing.noKetetapan,
        npwpSetor: item.billing.npwpSetor,
        kpp: item.billing.kpp,
        nop: item.billing.nop,
        billNumber: item.billing.billnum,
        expiredDate: item.billing.expiredDate,
        idWajibPajak: item.billing.idWajibPajak,
        amount: item.billing.amount,
        namaMap: item.billing.namaMap,
        namaJenisSetor: item.billing.namaJenisSetor,
        namaSetor: item.billing.namaSetor,
        ntpn: item.billing.ntpn,
        noFaktur: item.billing.noFaktur,
        uraian: item.billing.uraian,
        kodePemda: item.kasdaId,
        kdSkpd: this.content.info.kodeSkpd,
        noSpm: this.content.info.noSpm,
        jumlahDetail: item.billing.jumlahDetail,
        additionalData: {
          map: {
            mapId: item.billing.kodeMap,
            description: item.billing.namaMap
          },
          payType: {
            payType: item.billing.jenisSetoran==null?item.billing.jenisSetor:item.billing.jenisSetoran,
            description: item.billing.namaJenisSetoran
          }
        }
      }
    },
    showContent(value){
      this.billing = value ? value : null;
      if (this.billing) {
        this.editItem.billing.billnum = this.billing.billNumber;
        this.editItem.billing.expiredDate = this.billing.expiredDate;
        this.editItem.jenisSetoran = this.billing.jenisSetor;
        this.editItem.namaJenisSetoran = this.billing.namaJenisSetor;
        this.editItem.idBilling = this.billing.billNumber;
        this.editItem.nop = this.billing.nop;
        this.editItem.npwpSetor = this.billing.npwpSetor;
        this.editItem.noKetetapan = this.billing.noKetetapan;
        this.editItem.billing.namaSetor = this.billing.namaSetor;
        this.editItem.billing.idWajibPajak = this.billing.idWajibPajak;
        this.editItem.billing.namaWajibPajak = this.billing.nama;
        this.editItem.billing.alamatWajibPajak = this.billing.alamat;
        this.editItem.billing.noKetetapan = this.billing.noKetetapan;
        this.editItem.billing.kotaWajibPajak = this.billing.kota;
        this.editItem.billing.jenisSetor = this.billing.jenisSetor;
        this.editItem.billing.nop = this.billing.nop;
        this.editItem.billing.noFaktur = this.billing.noFaktur;
        this.editItem.billing.kodePemda = this.billing.kodePemda;
        this.editItem.billing.uraian = this.billing.uraian;
        this.editItem.billing.tahun = this.billing.tahun;
        this.doUpdateBilling(this.billing);
      }
    },
    doUpdateBilling(value){
      value.tahun=this.content.info.tahun
      value.additionalData.billing = this.editItem.billing;
      value.additionalData.accountNumber = this.content.source;
      value.additionalData.noTransaksi = this.content.info.noTransaksi;
      value.additionalData.customerRef = this.content.customerRef;
      this.$progress.show(true);
      this.$http.put("api/kasda/billing/" + this.content.summary.productCode, value)
          .then(success => {
            this.editItem.needCreateBilling = false;
            Object.assign(this.content.info.listPotongan[this.editIndex], this.editItem);
            this.$emit("updateContent",this.content)
            this.$message.success("Berhasil Membuat Billing");
            this.step = "1";
            this.$emit("showButton");
          }, err => {
            this.$message.error(err.response.data.message);
          }).finally(() => this.$progress.show(false));
    },
    setDataMap(item){
      this.mapData = [{mapId: item.kodeMap, description: item.namaMap}];
      this.payTypeData = item.listJenisSetoran.map(m => {
        return {
          mapId: m.mapId,
          payType: m.jenisSetoran,
          description: m.namaSetoran,
          validateNop: m.valNop,
          validateNoSk: m.valNoSk,
          validateNoFaktur: m.valFaktur,
          validateNpwpRekanan: m.valNpwpRekanan,
          validateNikRekanan: m.valNikRekanan,
          validateIdPeserta: m.valIdPeserta,
          validateNpwp: m.valNpwp,
        }
      });
    },
    emitEvents(event) {
      this.$emit(event);
    },
    doTransaction(item){
      this.editIndex = this.content.info.listPotongan.indexOf(item);
      this.editItem = Object.assign({}, item);
      let request = {
        productId: this.content.summary.productCode,
        noTransaksi: this.content.info.noTransaksi,
        noDokumen: this.content.info.noTransaksi,
        tahun: this.content.info.tahun,
        noRekening: this.content.source,
        kodeMap: this.editItem.kodeMap,
        billing: this.editItem.billing,
        noReference: this.content.requestId,
        noReferenceChannel:  this.referenceId
      };
      this.$progress.show(true);
      this.$http.post("api/kasda/billing", request)
          .then(success => {
            let response = success.data;
            if (response.status == 'SUCCESS') {
              this.editItem.billing = response.billing;
              if (response.detail) {
                this.editItem.detail = response.detail;
              }
              Object.assign(this.content.info.listPotongan[this.editIndex], this.editItem);
              this.$message.success("Data berhasil di transaksikan");
            } else if (response.status == 'SUSPECT') {
              this.editItem.billing = response.billing;
              if (response.detail) {
                this.editItem.detail = response.detail;
              }
              Object.assign(this.content.info.listPotongan[this.editIndex], this.editItem);
              this.$message.info("Data berhasil di transaksikan,namun belum mendapatakan ntpn");
            } else if (response.status == 'ALREADY_PAID') {
              this.editItem.billing.status = 'SUCCESS';

              Object.assign(this.content.info.listPotongan[this.editIndex], this.editItem);
              this.$message.success(response.message);
            }else if (response.status == 'FAILED') {
              this.editItem.billing.status = 'FAILED';
              if (response.detail) {
                this.editItem.detail = response.detail;
              }
              Object.assign(this.content.info.listPotongan[this.editIndex], this.editItem);
              this.$message.error(response.message);
            } else if (response.status == 'FAILED_EC') {
              this.editItem.billing.status = 'FAILED_EC';
              if (response.detail) {
                this.editItem.detail = response.detail;
              }
              Object.assign(this.content.info.listPotongan[this.editIndex], this.editItem);
              this.$message.error(response.message);
            } else if (response.status == 'CHANGE_BILLING') {
              this.editItem.billing = response.billing;
              if (response.detail) {
                this.editItem.detail = response.detail;
              }
              Object.assign(this.content.info.listPotongan[this.editIndex], this.editItem);
              this.$message.error(response.message);
            } else {
              this.$message.error(response.message);
            }
            if (response.billing||response.status == 'FAILED'||response.status == 'ALREADY_PAID') {
              this.updateDataResponse();
            }
          }, err => {
            this.$message.error(err.response.data.message);
          }).finally(() => this.$progress.show(false));
    },
    setEditItem(response) {
      if (response.detail) {
        this.editItem.detail = response.detail;
      }
      Object.assign(this.content.info.listPotongan[this.editIndex], this.editItem);
    },
    updateDataResponse(){
      this.$http.put("api/transaction/response", {
        referenceId: this.referenceId || '',
        productId: this.content.summary.productCode,
        dataResponse: this.content
      }).then(success => {
        this.$emit("dataResponse", this.content);
      }, err => {
        this.$message.error(err.response.data.message);
      });
    },
    formNewBilling(item){
      this.editIndex = this.content.info.listPotongan.indexOf(item);
      this.editItem = Object.assign({}, item);
      this.newBillnum = null;
      if (this.$refs.formBilling) {
        this.$refs.formBilling.resetValidation();
      }
      this.$emit("hideButton");
      this.step = "5";
    },
    showChangeBillingType(item) {
      this.item = item;
      if(this.edit) {
        this.showBillingForm(this.item);
      }else{
        // if (this.content.info.jenisDokumen == 'SP2D') {
        this.changeBillingType = "CHANGE";
        this.$emit("hideButton");
        this.step = "6";
        // } else {
        //   this.showChangeBilling(this.item);
        // }
      }
    },
    setFormChangeBilling() {
      if (this.item) {
        if (this.changeBillingType == 'CHANGE') {
          this.formNewBilling(this.item);
        }else{
          this.showBillingForm(this.item);
        }
      }else {
        this.$message.error("Tidak ada item yang di pilih");
      }
    },
    showBillingForm(item){
      this.autoInquiry = true;
      this.editIndex = this.content.info.listPotongan.indexOf(item);
      this.editItem = Object.assign({}, item);
      this.setDataMap(this.editItem);
      this.setBillingData(item);
      this.$emit("hideButton");
      this.step = "2";
    },
    changeBillnum(){
      if (this.$refs.formBilling.validate()) {
        let request = {
          productId: this.content.summary.productCode,
          noTransaksi: this.content.info.noTransaksi,
          noDokumen: this.content.info.noTransaksi,
          tahun: this.editItem.tahun,
          noRekening: this.content.source,
          kodeMap: this.editItem.kodeMap,
          billing: this.editItem.billing,
          newBillNum: this.newBillnum,
          noReference: this.content.requestId,
          noReferenceChannel:  this.referenceId
        };
        this.$progress.show(true);
        this.$http.put("api/kasda/change-billing", request)
            .then(success => {
              let response = success.data;
              if (response.status == 'SUCCESS') {
                this.editItem.billing = response.billing;
                this.editItem.idBilling = response.billing.billnum;
                Object.assign(this.content.info.listPotongan[this.editIndex], this.editItem);
                this.$message.success("Kode Billing berhasil di ubah");
                this.updateDataResponse();
                this.step = "1";
                this.sukses=true;
              }else{
                this.$message.error(response.message);
              }
            }, err => {
              this.$message.error(err.response.data.message);
            }).finally(() => this.$progress.show(false));
      }
    },
    doViewDetailPhri(item){
      this.editIndex = this.content.info.listPotongan.indexOf(item);
      this.editItem = Object.assign({}, item);
      this.phri = {
        noSts: item.detail.dataResponse.info.noSts,
        account: item.detail.dataResponse.info.account,
        customerName: item.detail.dataResponse.info.customerName,
        customerAddress: item.detail.dataResponse.info.customerAddress,
        handphone: item.detail.dataResponse.info.handphone,
        nop: item.detail.dataResponse.info.nop,
        anggaran: item.detail.dataResponse.info.anggaran,
        amount: item.detail.dataResponse.summary.amount,
      }
      this.$emit("hideButton");
      this.step = "5";
    },
  }
}
</script>
